import { createSlice } from "@reduxjs/toolkit";
import { IChatBotSlice } from "../../../models/common/IChatBot";

const initialChatBotDetails: IChatBotSlice = {
    message: undefined,
    response: undefined,
    aiPreviousChatMessage: undefined
};

const chatBotSlice = createSlice({
    name: "chatbot",
    initialState: initialChatBotDetails,
    reducers: {
        setMessage: (state, action: { payload: any }) => {
            state.message = action.payload;
        }, 
        setResponse: (state, action: { payload: any }) => {
            state.response = action.payload;
        },
        setAIPreviousMessages: (state, action: { payload: any }) => {
            state.aiPreviousChatMessage = action.payload;
        },
    },
});

export const { setMessage, setResponse, setAIPreviousMessages } = chatBotSlice.actions;

const chatBotReducer = chatBotSlice.reducer;

export type ChatBotState = ReturnType<typeof chatBotReducer>;

export default chatBotReducer;